import reducer from "./reducer";
export { default as RelatedTablesDefinition } from "./components/index";
export { default as relatedTablesDefinitionReducerName } from "./constants";
export default reducer;
